import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PayService } from "../models/pay-service";
import { ServiceType } from "../models/service-type";
import { UnitType } from "../models/unit-type";
import { UnitTypeService } from "../models/unit-type-service";

@Injectable({
	providedIn: 'root'
})

export class ServiceService {

	constructor(private http:HttpClient) { }

	getServiceTypes():Observable<ServiceType[]>{
		return this.http.get<ServiceType[]>('/api/service-types');
	}

	storeServiceTypeAdd(service_type:ServiceType):Observable<ServiceType>{
		return this.http.post<ServiceType>('/api/service-types', service_type);
	}

	updateServiceType(service_type:ServiceType, data:Object):Observable<ServiceType>{
		return this.http.post<ServiceType>('/api/service-types/'+service_type.id, data);
	}

	//Unit Type Services
	getUnitTypeService():Observable<UnitTypeService[]>{
		return this.http.get<UnitTypeService[]>('/api/unit-type-services');
	}

	getUnitTypeServices(unit_type:UnitType):Observable<UnitTypeService[]>{
		return this.http.get<UnitTypeService[]>('/api/service-types/unit-type-services/'+unit_type.id);
	}

	storeUnitTypeService(unit_type_service:UnitTypeService):Observable<UnitTypeService>{
		return this.http.put<UnitTypeService>('/api/service-types/unit-type-services', unit_type_service);
	}

	//Pay Services
	getPayServices(isMachinery:boolean = false):Observable<PayService[]>{
		let url = (isMachinery)?'/api/pay-services-owner':'/api/pay-services';
		return this.http.get<PayService[]>(url);
	}
	
	storePayService(pay_service:PayService):Observable<PayService>{
		return this.http.post<PayService>('/api/pay-services', pay_service)
	}

	updatePayService(pay_service:PayService):Observable<PayService>{
		return this.http.post<PayService>('/api/pay-services/'+pay_service.id, pay_service);
	}

	loadFilePayService(pay_service:PayService, file):Observable<any>{
		const data:FormData = new FormData();
        data.append('file', file, file.name);
        data.append('filename', file.name);
		return this.http.post<any>('/api/pay-services/'+pay_service.id+'/load-file', data);
	}

	downloadFilePayService(pay_service_id:number, filename:string):Observable<Blob>{
		return this.http.get<Blob>('/api/pay-services/'+pay_service_id+'/'+filename+'/download-file', {responseType: 'blob' as 'json'});
	}
}